import React, { Component } from 'react';
import InputText, { InputSelect, InputSelectMagasin } from '../../../../commonModules/interface/form-input-inline.jsx';
import FormLayout from '../containers/FormLayout.jsx';
import { Box, Button, Grid, TableRow, TableCell } from '@material-ui/core';
import DatePicker from '../../../../commonModules/MUI/DatePicker.jsx';
import { isEmpty } from 'lodash-es';

class FormInstall extends Component {
    state = { }
    
    createShopList = () => {
        const list = []
        const { SHOPS, AVAILABLE} = this.props
        if( AVAILABLE ){
            Object.values(SHOPS).map( shop => { 
                let selected = !!shop.shop_disabled || this.props.install.shop_id === shop.id
                
                list.push (       
                    {value:shop.id, label:shop.name, disabled:selected} 
                )
            })
        }
        return list
    }

    render() {
        const shops = this.createShopList()
        console.log("[DEBUG],this.props.install.shop_idDisplay",this.props.install)
        return (
            <Grid className="card-text">
                <h4 className="card-title">{this.props.update ? "Modifier l'installation" : ">Nouvelle Installation" }</h4>

                <Box p={2}>
                    <Grid container spacing={2} >
                        <Grid item xs={12}>
                            <InputSelectMagasin
                                options={[
                                    {value:"mjb", label:"Plateforme MyJouleBox"},
                                    {value:"other", label:"Autre plateforme"},
                                ]}
                                value={this.props.install.cli_typeDisplay}
                                onChange={(option) => this.props.handleSelect(option, "cli_type")}
                                error={this.props.errors.cli_type}
                                label="Type Client"
                                // isOptionDisabled={(option) => option.disabled === true}
                            /> 
                        </Grid>
                        
                        <Grid item xs={12}>
                            <InputSelectMagasin
                                options={shops}
                                value={this.props.install.shop_idDisplay}
                                onChange={(option) => this.props.handleSelect(option,"shop_id")}
                                // isOptionDisabled={(option)=>option.disabled === true}
                                error={this.props.errors.shop_id}
                                label="Magasin"
                                disabled={this.props.disabled}
                            /> 
                        </Grid>
                        <Grid item xs={12}>
                            <DatePicker 
                                label="Date d'installation prévue"
                                minDate={new Date()}
                                value={this.props.install.usage_date}
                                onChange={this.props.handleChangeDate}
                            />
                        </Grid>
                        
                        <Grid item xs={12}>
                            <FormLayout 
                                {...this.props} 
                                title={"Produits"}
                                createAddForm={this.props.createAddForm}
                                onClick={this.props.handleAddProd}
                                onClickForCSVUpload={this.props.handleAddProdByCSV}
                                rea
                                colSpan={2}
                                disabled={this.props.disabled}
                            /> 
                        </Grid>
                        <Grid item xs={12} >
                            <InputText
                                multiline
                                rows={4}
                                value={this.props.install.comments}
                                name="comments"
                                onChange={this.props.handleChange}
                                error={this.props.errors.comments}
                                label="Commentaire"
                            />
                        </Grid>
                    </Grid>
                        
                    <Box p={2} >
                        <div className="pull-right">
                            
                            <Button color="secondary" variant="contained" onClick={this.props.validate}>Valider</Button>
                            <Button color="secondary" onClick={this.props.handleClose}>Annuler</Button>
                        </div>                    
                    </Box>
                </Box>
            </Grid>
        );
    }
}

export default FormInstall;